webpackJsonp([70144966829960],{

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(8);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _reactObfuscate = __webpack_require__(420);
	
	var _reactObfuscate2 = _interopRequireDefault(_reactObfuscate);
	
	var _Main = __webpack_require__(40);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Article = __webpack_require__(39);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _PageHeader = __webpack_require__(45);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Content = __webpack_require__(44);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _config = __webpack_require__(43);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Footer = __webpack_require__(104);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*import Form from "../components/ContactForm";*/
	var styles = function styles(theme) {
	  return {};
	};
	
	var Contact = function Contact() {
	  return _react2.default.createElement(
	    _Main2.default,
	    null,
	    _react2.default.createElement(
	      _Article2.default,
	      null,
	      _react2.default.createElement(_PageHeader2.default, { title: "Contact" }),
	      _react2.default.createElement(
	        _Content2.default,
	        null,
	        "Have you made a new surf helmet or simply, a water-tight helmet that you think could be used surfing? Please contact me! You can reach me by email:",
	        " ",
	        _react2.default.createElement(_reactObfuscate2.default, { email: _config2.default.contactEmail }),
	        ".",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "I'm also very interested in other surfer's experiences while using these helmets, or any other helmets capable of getting in the surf that I've missed (",
	        _react2.default.createElement(
	          "a",
	          {
	            href: "https://issuu.com/f-one/docs/ocean_helmets_2012",
	            target: "_blank"
	          },
	          "I know of one"
	        ),
	        ", but it's no longer available). If you are interested in providing a review or testimonial, please email me!",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "I'm also happy to address any other comments, questions or concerns."
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	Contact.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(Contact);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-16b920ea2ec57d928824.js